import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../../../Context/UserContextProvider";
import axios from "../../../../axios/index"

import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const StaffSupportCardDetail = (props) => {
    const history = useHistory()
    const { userToken } = useContext(UserContext);
    const [modalShow, setModalShow] = useState(false);
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [btnLoader, setBtnLoader] = useState(false)

    const [formStaffMessage, setFormStaffMessage] = useState({
        id: 1,
        messageText: "",
        status: "",
        recivedText: "",
        sentMessage: "",
        fileData: ""
    })

    const formStaffMessageChangeHandler = (e) => {
        setFormStaffMessage({
            ...formStaffMessage,
            [e.target.name]: e.target.value
        })
    }

    useEffect(() => {
        const getData = async () => {
            // setIsLoading(true)
            const getApiData = await axios.get(
                `Ticket/UserTicket/${state?.id}/${state?.userId}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            setFormStaffMessage({
                ...formStaffMessage,
                recivedText: getApiData.data.data.body,
                status: getApiData.data.data.status,
                sentMessage: getApiData.data.data.messages,
                fileData: getApiData.data.data.estateDto
            })
            // console.log(getApiData.data.data)
            setIsLoading(false)
        }
        getData()
    }, [userToken, state])


    return (
        <>

            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <ToastContainer
                position="top-right"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                        dir="rtl"
                                    >
                                        <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                            <a href="#" onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                            <div className={styles.text1}>
                                                پشتیبانی
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Staff Support Detail */}

                                    <div dir="rtl" className={`mt-3 mx-4 pt-1 px-2 d-flex justify-content-between align-items-center flex-wrap`}>
                                        <div className={`d-flex justify-content-start align-items-center`}>
                                            <img className={`${styles.image_staff_card_detail}`} src={`https://backdev.azrmelk.com/images/users/avatar/${state?.receiverUserDto?.avatarName}`} alt="user-profile" />
                                            <div className={`me-3 text-right`}>
                                                <h4 className={`${styles.title_head_staff_card_box}`}> {state?.receiverUserDto?.fullName} </h4>
                                                {/* <p className={`mb-0 ${styles.subTitle_head_staff_card_box}`}> سرپرست منطقه یک و دو تبریز </p> */}
                                            </div>
                                        </div>
                                        <div>
                                            <div className={`me-3 text-right`}>
                                                <div className="mb-3 d-flex align-items-center">
                                                    <span style={{ color: "#8D8D8D" }} className={`ps-2 ${styles.subTitle_staff_card_box}`}> وضعیت: </span> <span style={{ color: state?.status === 2 ? "#8D8D8D" : state?.status === 3 && "#127442" }} className={`${styles.subTitle_staff_card_box}`}>
                                                        {state?.status === 2 ? "پاسخ داده شده" : state?.status === 3 && "پاسخ داده نشده"}
                                                    </span>
                                                </div>
                                                <div className="mt-3 d-flex align-items-center">
                                                    <span style={{ color: "#8D8D8D" }} className={`ps-2 ${styles.subTitle_staff_card_box}`}> تاریخ: </span> <span style={{ color: "#363636" }} className={`${styles.subTitle_staff_card_box}`}>
                                                        {state?.createDate?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div dir="rtl" className={`mt-4 mx-4 pt-4 px-2`}>
                                        <div className={`position-relative p-3 d-flex justify-content-between align-items-end flex-wrap ${styles.total_staff_support_card_file_box}`}>
                                            <div className={`pe-4 me-2 ${styles.total_title_staff_support_card_file_box}`}>
                                                <p style={{ color: "#8D8D8D" }} className={`mb-4 mb-0 text-right ${styles.subTitle_staff_card_box}`}> مربوط به فایل </p>
                                                {/* <h5 className={`mb-0 ${styles.title_secondary_staff_card_box}`}> نام فایل اینجا نوشته شود </h5> */}
                                                <span style={{ color: "#8D8D8D" }} className={`ps-2 ${styles.subTitle_staff_card_box}`}> شناسه فایل: </span> <span className={`${styles.title_secondary_staff_card_box}`}>
                                                    {state?.fileCode?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                                </span>
                                            </div>
                                            <Link to={{
                                                pathname: `/card-detail/${formStaffMessage?.fileData?.id}`,
                                                state: {
                                                    state: formStaffMessage?.fileData,
                                                    isArchive: false
                                                }
                                            }} className={`ms-md-2 ms-sm-0 me-auto ${styles.link_icon_text}`}>
                                                مشاهده فایل مربوطه
                                                <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="12" />
                                            </Link>
                                        </div>
                                    </div>

                                    <div dir="rtl" className={`mt-4 mx-4 pt-4 px-2`}>
                                        <div className={`text-right`}>
                                            <h5 className={`mb-4 ${styles.title_staff_message_consultant_card_box}`}>
                                                {formStaffMessage?.recivedText}
                                            </h5>
                                            <p className={`${styles.text_staff_message_consultant_card_box}`}>
                                                {formStaffMessage?.recivedText}
                                            </p>
                                        </div>
                                    </div>

                                    <div dir="rtl" className={`mt-5 mx-4 pt-5 px-2`}>
                                        <div className={`text-right`}>

                                            {
                                                formStaffMessage?.status === 3 ? (
                                                    <>
                                                        <h5 className={`mb-4 ${styles.title_staff_reply_card_box}`}> ارسال پاسخ </h5>
                                                        <Form.Group className={`${styles.total_form_group} mb-4 pb-4 d-flex flex-column w-100`}>
                                                            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="messageText"> متن پیام </Form.Label>
                                                            <Form.Control
                                                                style={{ resize: "none" }}
                                                                className={`${styles.form_control_input} shadow-none`}
                                                                as="textarea"
                                                                rows={9}
                                                                placeholder="متن پیام اینجا نوشته شود"
                                                                id="messageText"
                                                                name="messageText"
                                                                value={formStaffMessage.messageText}
                                                                onChange={formStaffMessageChangeHandler}
                                                            />
                                                        </Form.Group>

                                                        <div className="d-flex justify-content-end align-items-center mt-5 mb-2">
                                                            {btnLoader ? (
                                                                <div className={Dstyles.btn_loader_container}>
                                                                    <div className={Dstyles.btn_spinner}></div>
                                                                </div>
                                                            )
                                                                : (
                                                                    <div className={`${styles.total_save_btn} text-center d-flex justify-content-center align-items-center me-3`} role="button" onClick={formSaveHandler}>
                                                                        <button className={`border-0 bg-transparent text-white`}>ارسال</button>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </>
                                                ) :
                                                    formStaffMessage?.status === 2
                                                    && (
                                                        <>
                                                            <h5 className={`mb-4 ${styles.title_staff_reply_card_box}`}> پاسخ شما </h5>
                                                            {formStaffMessage?.sentMessage?.map((item) => (
                                                                <p key={item.id} className={`${styles.text_staff_reply_card_box}`}>
                                                                    {item.message}
                                                                </p>
                                                            ))}
                                                        </>
                                                    )
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu managePersonal manageSupportStaff />
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}
        </>
    )

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    async function formSaveHandler() {
        try {
            if (formStaffMessage.messageText !== "") {
                notify("درحال ارسال پیام", "success")
                setIsLoading(true)
                var data = new FormData();
                data.append('TicketId', state.id);
                data.append('MessageBody', formStaffMessage.messageText);
                const apiData = await axios.post(
                    "Ticket/AddMessageToTicket",
                    data,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                setIsLoading(false)
                notify("پیام با موفقیقت ارسال شد", "success")
                history.replace("/staff-managment-support")
            } else {
                notify("لطفا تمام فیلد هارا وارد کنید", "error")
            }
        } catch (error) {
            notify("خطای سرور", "error")
        }
    }
}

export default StaffSupportCardDetail;
